// bind_Modal
import bind_modal from '@/components/AreaBind';

// rule_modal
import rule_modal from '@/components/RuleModal';

//pack_comfirm
import pack_comfirm from '@/components/PackComfirm';

// result_modal
import result_modal from '@/components/ResultModal';

// invite_modal
import invite_modal from '@/components/InviteModal';

//copy_modal
import copy_modal from '@/components/CopyModal';

//invite_modal
import invite_apply from '@/components/InviteApply';

//msg_modal
import msg_modal from '@/components/MsgModal';

//comfirmwarn_modal
import comfirmwarn from '@/components/ComfirmWarn';

//comfirmwarn_trade
import comfirmwarn_trade from '@/components/ComfirmTrade';

//comfirmwarn_score
import comfirmwarn_score from '@/components/ComfirmScore';

//record_modal
import record_modal from '@/components/RecordModal';

//friend_modal
import friend_modal from '@/components/FriendModal';

// //toast
// import toast from '@/components/Toast';

let utils = {
    $bind_modal : bind_modal,
    $rule_modal : rule_modal,
    $pack_comfirm : pack_comfirm,
    $result_modal : result_modal,
    $invite_modal : invite_modal,
    $invite_apply : invite_apply,
    $msg_modal : msg_modal,
    $copy_modal : copy_modal,
    $comfirmwarn : comfirmwarn,
    $comfirmwarn_trade : comfirmwarn_trade,
    $record_modal : record_modal,
    $friend_modal : friend_modal,
    $comfirmwarn_score : comfirmwarn_score,
    // $toast : toast,
}

export default utils;